import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {RouterOutlet} from '@angular/router';

@Component({
  selector: 'motn-manage-prop-manager',
  template: '<router-outlet></router-outlet>',
  styleUrls: ['./manage-prop-manager.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    RouterOutlet,
  ],
})
export class ManagePropManagerComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
